// extracted by mini-css-extract-plugin
export default {"box":"date_box__UhQ1L"};